'use client';

import {Autocomplete, TextField} from '@mui/material';
import {useRouter} from 'next/navigation';
import React from 'react';

interface StatusOption {
    value: string;
    label: string;
    colorClass: string;
}

interface Props {
    uuid: string;
    currentStatuses: string[];
    current: Record<string, string | undefined>;
    statusOptions: StatusOption[];
}

const buildHref = (
    uuid: string,
    current: Record<string, string | undefined>,
    patch: Record<string, string | undefined>,
): string => {
    const next = {...current, ...patch};
    const params = new URLSearchParams();
    Object.entries(next).forEach(([k, v]) => {
        if (v !== undefined && v !== '') params.set(k, v);
    });
    const qs = params.toString();
    return `/manage/${uuid}${qs ? `?${qs}` : ''}`;
};

export default function ManageStatusFilter({uuid, currentStatuses, current, statusOptions}: Props) {
    const router = useRouter();

    const selectedOptions = statusOptions?.filter((opt) =>
        currentStatuses.includes(opt.value)
    );

    const handleChange = (_: any, newValue: StatusOption[]) => {
        const next = newValue.map((opt) => opt.value).join(',');
        router.push(buildHref(uuid, current, {status: next, page: '1'}));
    };

    return (
        <Autocomplete
            multiple
            sx={{
                '& .MuiOutlinedInput-root': {
                    paddingRight: '40px !important',
                },
            }}
            options={statusOptions}
            size="small"
            getOptionLabel={(option) => option?.label}
            value={selectedOptions ?? []}
            onChange={handleChange}
            isOptionEqualToValue={(option, value) => option.value === value.value}
            renderInput={(params) => (
                <TextField
                    {...params}
                    label='Filter by status'
                    size='small'
                />
            )}
            style={{minWidth: 280}}
            renderOption={(props, option) => {
                const {key, ...restProps} = props;
                return (
                    <li key={key} {...restProps}>
                        <span className={`calendar-button-dot mx-1 ${option.colorClass}`}>
                            {option.label}
                        </span>
                    </li>
                );
            }}
        />
    );
}